import React from "react";

function HourlyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#fff"
        d="M256 512C115.39 512 0 396.61 0 256c0-67.397 27.88-132.188 75.18-179.795L64.267 60.648a15.047 15.047 0 01-1.099-15.381 15.034 15.034 0 0113.052-8.232l108.135-2.476c4.512.571 9.756 2.3 12.627 6.401s3.501 9.375 1.685 14.048L159.364 155.79a14.997 14.997 0 01-12.188 9.448c-5.552.674-10.898-1.772-14.077-6.299l-4.98-7.119C104.066 181.19 91 217.577 91 256c0 90.981 74.019 165 165 165s165-74.019 165-165c0-8.291 6.709-15 15-15h61c8.291 0 15 6.709 15 15 0 140.61-115.39 256-256 256z"
        data-original="#ffdf40"
      ></path>
      <path
        fill="#ff9f40"
        d="M398.896 173.5c-4.146-7.178-1.685-16.348 5.493-20.493l51.958-30c7.119-4.175 16.333-1.714 20.493 5.493 4.146 7.178 1.685 16.348-5.493 20.493l-51.958 30c-7.153 4.132-16.345 1.691-20.493-5.493zM338.5 113.104c-7.178-4.146-9.639-13.315-5.493-20.493l30-51.958c4.146-7.192 13.33-9.653 20.493-5.493 7.178 4.146 9.639 13.315 5.493 20.493l-30 51.958c-4.156 7.197-13.354 9.617-20.493 5.493z"
        data-original="#ff9f40"
      ></path>
      <path
        fill="#ffbe40"
        d="M256 91c-8.291 0-15-6.709-15-15V15c0-8.291 6.709-15 15-15s15 6.709 15 15v61c0 8.291-6.709 15-15 15z"
        data-original="#ffbe40"
      ></path>
      <path
        fill="#ff9f40"
        d="M415.375 213.3c-2.138-7.998 2.608-16.23 10.606-18.369l57.964-15.527c8.027-2.139 16.245 2.593 18.369 10.605 2.139 7.998-2.607 16.23-10.605 18.369l-57.964 15.527c-7.924 2.137-16.222-2.54-18.37-10.605zm-42.7-73.975c-5.859-5.859-5.859-15.352 0-21.211l42.422-42.422c5.859-5.859 15.352-5.859 21.211 0s5.859 15.352 0 21.211l-42.422 42.422c-5.859 5.859-15.352 5.86-21.211 0zm-73.975-42.7c-7.998-2.139-12.744-10.371-10.605-18.369l15.527-57.964c2.153-7.983 10.386-12.715 18.369-10.605 7.998 2.139 12.744 10.371 10.605 18.369L317.069 86.02c-2.159 8.089-10.482 12.732-18.369 10.605z"
        data-original="#ff9f40"
      ></path>
      <path
        fill="#443d66"
        d="M301 241c-5.284 0-10.285 1.082-15 2.763V226c0-8.291-6.709-15-15-15s-15 6.709-15 15v90c0 8.291 6.709 15 15 15s15-6.709 15-15v-30c0-8.276 6.724-15 15-15s15 6.724 15 15v30c0 8.291 6.709 15 15 15s15-6.709 15-15v-30c0-24.814-20.186-45-45-45z"
        data-original="#443d66"
      ></path>
      <path
        fill="#4d4d80"
        d="M216.742 182.143c-5.596-2.314-12.07-1.04-16.348 3.252l-30 30c-5.859 5.859-5.859 15.352 0 21.211s15.352 5.859 21.211 0l4.395-4.395V316c0 8.291 6.709 15 15 15s15-6.709 15-15V196a14.983 14.983 0 00-9.258-13.857z"
        data-original="#4d4d80"
      ></path>
      <path
        fill="#ff9f40"
        d="M271 76V15c0-8.291-6.709-15-15-15v91c8.291 0 15-6.709 15-15z"
        data-original="#ff9f40"
      ></path>
      <path
        fill="#ffbe40"
        d="M512 256c0-8.291-6.709-15-15-15h-61c-8.291 0-15 6.709-15 15 0 90.981-74.019 165-165 165v91c140.61 0 256-115.39 256-256z"
        data-original="#ffbe40"
      ></path>
    </svg>
  );
}

export default HourlyIcon;